import { ReactNode } from "react";
import DeezerLogo from "../../assets/images/deezer_logo.svg";
import styles from "./styles.module.scss";

interface LayoutContainerProps {
  children: ReactNode;
}

export function LayoutContainer({ children }: LayoutContainerProps) {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.navbar}>
          <img src={DeezerLogo} alt="Logo Deezer" className={styles.logo} />
        </div>
        <div className={styles.contentContainer}>{children}</div>
      </div>
    </>
  );
}
